export const environment = {
  production: false,
  extension: false,
  service_url: 'https://mx.pdfskillsapp.com/',
  path: {
    merge: 'api/merge/',
    convert: 'api/convert/',
    optimize: 'api/optimize/'
  }
};
